import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import Card from '../../../../../1stlog-ui/src/components/Card'
import { Col } from '../../../../../1stlog-ui/src/components/Bootstrap'
import { useField } from '../../../../../1stlog-ui/src/components/Field'
import useOrderEntry from '../../useOrderEntry'
import useTransport from '../../Form/Transport/useTransport'
import { ProductsContextProvider } from '../../Products/ProductsContext'
import ProductSummary from './ProductSummary'
import { usePickupProduct, useDeliveryProduct } from '../../Products'

const Transport = (props) => {
  const {} = props

  const {
    preset,
    // if not internal, disallow usage of pickup AND delivery products
    isInternal
  } = useOrderEntry()

  const isPickup = useField('isPickup')
  const isDelivery = useField('isDelivery')

  const pickupProduct = usePickupProduct()
  const deliveryProduct = useDeliveryProduct()

  const { isMixedTransport, requirePickupProduct, requireDeliveryProduct } = useTransport()

  const allowPickupProduct = isPickup || requirePickupProduct
  const allowDeliveryProduct = isDelivery || requireDeliveryProduct

  const isPickupAndDelivery = isPickup && isDelivery

  return (
    <>
      {allowPickupProduct && (
        <Col md={isPickupAndDelivery ? 6 : 12}>
          <Card
            title={
              isPickupAndDelivery
                ? i18n.t('transport_pickup', 'Abholung')
                : i18n.t('transport_general', 'Transport')
            }
            customContentPaddingClass="p-0"
          >
            <ProductsContextProvider id="pickup">
              <div className="p-2">
                <ProductSummary isPickup product={pickupProduct} />
              </div>
            </ProductsContextProvider>
          </Card>
        </Col>
      )}
      {allowDeliveryProduct && (
        <Col md={isPickupAndDelivery ? 6 : 12}>
          <Card
            title={
              isPickupAndDelivery
                ? i18n.t('transport_delivery', 'Zustellung')
                : i18n.t('transport_general', 'Transport')
            }
            customContentPaddingClass="p-0"
          >
            <ProductsContextProvider id="delivery">
              <div className="p-2">
                <ProductSummary product={deliveryProduct} />
              </div>
            </ProductsContextProvider>
          </Card>
        </Col>
      )}
    </>
  )
}

export default Transport
